// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCommercialAgreementOffers } from '../../hooks/queries/commercialAgreements/useCommercialAgreementOffers';
import { useCommercialAgreements } from '../../hooks/queries/commercialAgreements/useCommercialAgreements';
import { Row } from './useCreateCommercialAgreementActions';

export const useCreateCommercialAgreementRows = () => {
  const agreements = useCommercialAgreements();
  const agreementOffers = useCommercialAgreementOffers();
  const isLoading =
    agreements.isLoading || agreementOffers.isLoading || !agreements.data || !agreementOffers.data;
  const rows = (agreements.data || [])
    .map(
      (d) =>
        ({
          contractId: d.contractId as string,
          state: 'Accepted',
          payload: {
            operator: d.payload.operator,
            user: d.payload.user,
            feeReceiver: d.payload.feeReceiver,
            rewardReceiver: d.payload.rewardReceiver,
            utilityFees: d.payload.utilityFees.credentialBillingFeeUsd,
            depositedAmount: d.payload.currentLockedAmuletAmountCc,
            accruedFeesCc: d.payload.accruedFeesCc,
            ratePerDay: d.payload.utilityFees.baseFee?.feePerDayUsd.rate,
            billingPeriodMinutes: d.payload.utilityFees.baseFee?.billingPeriodMinutes,
            baseFeelastBilledAt: d.payload.baseFeeBillingState?.lastBilledAt,
            baseFeeState: d.payload.baseFeeBillingState?.status.tag,
            credentialFeeLastBilledAt: d.payload.credentialFeeBillingState?.lastBilledAt,
            credentialFeeState: d.payload.credentialFeeBillingState?.status.tag,
          },
        }) as Row,
    )
    .concat(
      (agreementOffers.data || []).map(
        (d) =>
          ({
            contractId: d.contractId as string,
            state: 'Offered',
            payload: {
              operator: d.payload.operator,
              user: d.payload.user,
              feeReceiver: d.payload.feeReceiver,
              rewardReceiver: d.payload.rewardReceiver,
              utilityFees: d.payload.utilityFees.credentialBillingFeeUsd,
              ratePerDay: d.payload.utilityFees.baseFee?.feePerDayUsd.rate,
              billingPeriodMinutes: d.payload.utilityFees.baseFee?.billingPeriodMinutes,
            },
          }) as Row,
      ),
    );
  return { rows, isLoading };
};
